import { gql } from "@apollo/client";

export const CREATE_EMPLOYEE_INSURANCE_DOCS = gql`
  mutation CreateEmployeeInsuranceDocs($input: CreateEmployeeInsuranceDocsInput!) {
  createEmployeeInsuranceDocs(input: $input) {
    userId
  }
}
`;

export const UPDATE_EMPLOYEE_INSURANCE_DOCS = gql`
  mutation UpdateEmployeeInsuranceDocs($input: UpdateEmployeeInsuranceDocsInput!) {
  updateEmployeeInsuranceDocs(input: $input)
}
`;

export const GET_EMPLOYEE_INSURANCE_DOCS = gql`
 query EmployeeInsuranceDocs($userId: String!) {
  employeeInsuranceDocs(userId: $userId) {
    Id
    userId
    healthInsuranceUrl
    category
    lifeInsuranceUrl
    otherInsuranceType
    otherInsuranceUrl
    createdAt
  }
}
`;
